import React, { Component } from "react";

// Elements
import Count from "../elements/counter-sensor";

// Images
import bg1 from "../../images/background/bg1.png";
import aboutPic1 from "../../images/about/pic2.jpg";
import aboutPic2 from "../../images/about/pic3.jpg";

class AboutUsForIndex extends Component {
  render() {
    return (
      <>
        <section
          className="section-area about-wraper1 bg-gray section-sp1"
          style={{ backgroundImage: "url(" + bg1 + ")", backgroundRepeat: "no-repeat" }}
        >
          <div className="container">
            <div className="row">
              <div className="col-lg-6 about-media mb-30">
                <div className="about-img1">
                  <img src={aboutPic1} alt="Bilservice och lackering - Kungälv Bilskadecenter team arbetar på en bil" />
                </div>
                <div className="about-img2">
                  <img src={aboutPic2} alt="Moderna verktyg och utrustning i Kungälv Bilskadecenter" />
                </div>
                <div className="experience-bx">
                  <h4 className="exp-text">
                    <span className="counter">
                      <Count counter={10} />
                    </span>
                    +
                  </h4>
                  <h6 className="exp-year">erfarenhetsår</h6>
                </div>
              </div>
              <div className="col-lg-6 mb-30">
                <div className="heading-bx">
                  <h1 className="title mb-0 h3">VÄLKOMMEN TILL KBS CENTER - DIN BILVERKSTAD I KUNGÄLV</h1>
                  <p>
                    Hos oss hittar du allt du behöver för att ta hand om din bil. Vi erbjuder professionella
                    bilservice-, lackerings- och reparationsarbeten med fokus på kvalitet, noggrannhet och kundnöjdhet.
                    Vår verkstad är utrustad med den senaste tekniken för att hantera alla bilmärken och modeller.
                  </p>
                  <h2 className="h4">DIN BILVERKSTAD I KUNGÄLV MED ALLT UNDER ETT TAK</h2>
                  <p>
                    Vi är specialister på att ge din bil bästa möjliga omsorg. Med tjänster som skadereparation,
                    däckservice, lackering och rekond, ser vi till att din bil inte bara fungerar felfritt utan också
                    ser fantastisk ut. Vi arbetar med både privatpersoner och företag och har lång erfarenhet av
                    samarbete med försäkringsbolag.
                  </p>
                  <h3 className="h5">VARFÖR VÄLJA OSS?</h3>
                  <ul>
                    <li className="square-list">Erfarna och utbildade tekniker</li>
                    <li className="square-list">Moderna verktyg och utrustning</li>
                    <li className="square-list">Skräddarsydda lösningar för dina behov</li>
                    <li className="square-list">Konkurrenskraftiga priser</li>
                    <li className="square-list">Högkundnöjdhet</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </section>
      </>
    );
  }
}

export default AboutUsForIndex;
